import { render, staticRenderFns } from "./ListPhoneNumber.vue?vue&type=template&id=45077db0&scoped=true&"
import script from "./ListPhoneNumber.vue?vue&type=script&lang=js&"
export * from "./ListPhoneNumber.vue?vue&type=script&lang=js&"
import style0 from "./ListPhoneNumber.vue?vue&type=style&index=0&id=45077db0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45077db0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VDataTable})
